import React from 'react'
import styled from 'styled-components'

const GroupInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: ${(props) => props.width || '100%'};

  .label {
    font-size: 12px;
    color: #2d2d2d;
    font-weight: 600;
  }

  .input {
    border: none;
    font-size: 12px;
    color: ${(props) => props.textColor || '#2d2d2d'};
    padding-block: 6px;
    padding-inline: 6px;

    width: ${(props) => props.width || '100%'};
    border: 1px solid;
    border-color: ${(props) => (props.error ? '#ff0000' : '#CFCFCF')};
    outline: none;

    font-weight: ${(props) => props.fontWeigth || 'normal'};

    &:focus {
      border-color: ${({ color }) => color || '#ffa200'};
      outline: ${({ color }) => `1px solid ${color || '#ffa200'}`};

      /* Se houver erro */
      ${(props) => props.error && 'border-color: #ff0000; outline: 1px solid #ff0000;'}
    }
  }
`

export const Input = React.forwardRef(({ error, ...props }, ref) => {
  const { label, id, ...restProps } = props

  return (
    <GroupInput
      width={props.width}
      error={error}
      color={props.color}
      textColor={props.textColor}
      fontWeigth={props.fontWeigth}
      className="group-input"
    >
      <label htmlFor={id || label} className="label">
        {label}
      </label>
      <input ref={ref} id={id || label} {...restProps} className="input" />
    </GroupInput>
  )
})
